var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomRightAgenda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 445,
    viewBox: "0 0 268 445",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268 321V143L143 321H268Z",
    fill: "#A8BFFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M392.464 102.547C346.75 109.178 245.047 147.028 203.957 245.375C162.867 343.722 53.5315 350.985 4.00006 342.323",
    stroke: "#DDE6FD",
    strokeWidth: 40
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRightAgenda);
export default __webpack_public_path__ + "static/media/bottom_right_agenda.cdd0acda382c08ab4a5ab561edc8a8b9.svg";
export { ForwardRef as ReactComponent };